export default __webpack_public_path__ + "static/A05-af2cd995c5ccf6afe9236efbd0150bca.jpg";